export default "/images/69e41f6996f365fcd2e7ef57ade74577.jpg";